module.exports = __webpack_public_path__ + "img/photoAlbum1.c9204a02.jpg";